<template>
    <gs-named-modal class="gs-refresh-controls" name="add-clawback-modal" :title="$t('frontend_groovesell_add_clawback')" bg-type="regular">
        <div v-if="selectedAffiliate" class="flex">
            <div class="flex flex-col w-full px-4">
                <div class="mt-2">
                    <div class="w-full flex flex-row mb-4">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_amount')
                        }}</label>
                        <div class="w-2/3">
                            <gd-currency-input v-model="clawback.amount" currency-code="USD" />
                        </div>
                    </div>
                    <div class="w-full flex flex-row mb-4">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_transaction')
                        }}</label>
                        <text-input v-model="clawback.transactionId" :validator="validation.clawback.transactionId"
                            :attribute="$t('frontend_affiliate_index_transaction_id')" class="w-2/3"
                            value="clawback.transactionId" :placeholder="$t('frontend_affiliate_index_transaction_id')" />
                    </div>
                    <div class="w-full flex flex-row mb-4">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_comment')
                        }}</label>
                        <text-input v-model="clawback.comment" :validator="validation.clawback.comment"
                            :attribute="$t('frontend_affiliate_index_comment')" class="w-2/3" value="clawback.comment"
                            :placeholder="$t('frontend_affiliate_index_comment')" />
                    </div>
                    <div class="flex flex-row w-full mb-6 justify-end">
                        <gs-button size="md" class="mb-4" variant="primary" @click="addClawback()">{{
                            $t('frontend_affiliate_index_add_clawback')
                        }}</gs-button>
                    </div>
                </div>
            </div>
        </div>
    </gs-named-modal>
</template>
<style scoped>
@media (max-width: 640px) {
    .flex.flex-row {
        min-width: 0;
        flex-wrap: wrap;
    }

    .flex.flex-row > [class~="w-1/3"],
    .flex.flex-row > [class~="w-2/3"] {
        width: 100%;
    }
}
</style>
<script>
export default {
    props: {
        selectedAffiliate: {
            type: Object,
            default: null
        },
        addClawback: {
            type: Function,
            default: null
        },
        validation: {
            required: true,
        }
    },
    data() {
        return {
            clawback: {
                amount: 0,
                transactionId: '',
                comment: ''
            }
        }
    },
    watch: {
        clawback: {
            handler: function (val, oldVal) {
                this.validation.clawback.$touch();
                this.$emit('update-clawback', val);
            },
            deep: true
        }
    },
   
}
</script>
